import flash from "@/services/flash";

export default async (to, from, next) => {
  flash();

  next();
};
